import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

import {PaymentSummaryResponse, PaymentSummaryRequest, EDIT_BTN} from '../shared';
import { CommonUtility, ServerConstantsService, DataService, APP_DATE_FORMAT } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss']
})
export class PaymentSummaryComponent implements OnInit {
  payments: PaymentSummaryResponse[];
  payment: PaymentSummaryResponse;
  request:PaymentSummaryRequest;
  referralId: string = '';
  wpPersonId: string = '';
  activityArray:any[];
  activityMap:any;
  entitlementArray:any[];
  entitlementMap:any;
  programArray:any[];
  programMap:any;
  refData: any;
  activityCd:any;
  ServerConstants: any;
  sharedData: any;
  paymentStatusArray:any[];
  paymentStatusMap:any;
  userActionNotificationsMap: any;

  error: Boolean = false;
  errorRadioConcilliation:Boolean = false;
  errorRadioGoodCause:Boolean = false;
  noData: Boolean = false;

  private _success = new Subject<string>();
  successMessage: string;

  private _danger = new Subject<string>();
  errorMessage: string;
  APP_DATE_FORMAT = APP_DATE_FORMAT;
  EDIT_BTN: string = EDIT_BTN;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }

  ngOnInit() {
    this.sharedData = this.dataService.getSharedDataObject();

    /* set global values for page */
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.request = new PaymentSummaryRequest( parseInt(this.referralId) ,parseInt(this.wpPersonId) );

    /* Load Reference Tables*/
    this.data.currentMessage.subscribe(
     (message) => {
         this.refData = message;
         this.parseRefTableData(message);
     });

    this.load(this.request);

    /* Success message*/
    this._success.subscribe((message) => this.successMessage = message);
    this._success.pipe(
      debounceTime(5000)
    ).subscribe(() => this.successMessage = null);
    /* error message */
    this._danger.subscribe((message) => this.errorMessage = message);
    this._danger.pipe(
      debounceTime(5000)
    ).subscribe(() => this.errorMessage = null);
  }

   load(request){
      this.http.post<PaymentSummaryResponse[]>(this.ServerConstants.PAYMENT_SERVER_API_URL+'/paymentsummary/load', request ).subscribe(
        (data) => {
            if(data.hasOwnProperty('errorCode')){
              this.notificationService.error('Payment Summary', this.userActionNotificationsMap.ERROR);
            }else{
              if (data.length > 0 ){
                this.payments = data;
              }else{
                this.payments = undefined;
                this.noData = true;
              }
            }
        },response => {
            this.error = true;
            this.notificationService.error('Payment Summary', this.userActionNotificationsMap.ERROR);
        },() => {
            this.error = false;
        });
  }
  editPayment(wpReferralId, wpPersonId, wpPaymentId){
      this.dataService.addValueToSharedDataMap("wpPaymentId", wpPaymentId);
      this.router.navigate(['task/requestPayment']);
  }

  addPayment(wpReferralId, wpPersonId){
      this.dataService.removeValueFromSharedDataMap("wpPaymentId");
      this.router.navigate(['task/requestPayment']);
  }

  parseRefTableData(myData){
      if(myData != undefined && myData.englishDropDown){
         this.programArray = myData.englishDropDown["PROGRAMS"];
         this.programMap = this.commonUtil.createMapFromList(this.programArray);

         this.entitlementArray = myData.englishDropDown["ENTITLEMENT"];
         this.entitlementMap = this.commonUtil.createMapFromList(this.entitlementArray);

        this.activityArray = myData.englishDropDown["ACTIVITIES"];
        this.activityMap = this.commonUtil.createMapFromList(this.activityArray);

        this.paymentStatusArray = myData.englishDropDown["PAYMENTSTATUS"];
        this.paymentStatusMap = this.commonUtil.createMapFromList(this.paymentStatusArray);

        this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
      }
  }

  convertCode(myMap, code){
    if(myMap != undefined){
       return myMap.get(code);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/payment-summary/payment-summary.component.ts